module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "map"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062290953_Map",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MAP")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ded"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062290953_Dedication",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DEDICATION")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ack"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062290953_Acknowledgement#rack",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ACKNOWLEDGMENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-1",
    attrs: {
      "id": "pro"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780062290953_Prologue"
    }
  }, [_vm._v("PROLOGUE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch01"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780062290953_Chapter_1"
    }
  }, [_vm._v("I • BIRTH PANGS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch02"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062290953_Chapter_2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II • A SHADOW ON THE MOON")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch03"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062290953_Chapter_3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III • FIRST BLOOD")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch04"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062290953_Chapter_4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV • LADY OF THE EASTERN GATE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch05"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062290953_Chapter_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V • THE FLOWER BRIDE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch06"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062290953_Chapter_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI • THE SACRED ROUND")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch07"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062290953_Chapter_7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII • THE WOUNDED KING")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch08"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062290953_Chapter_8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII • THE GREAT QUEEN")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch09"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062290953_Chapter_9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX • A VESSEL OF LIGHT")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062290953_Chapter_10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X • THE QUEST")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062290953_People_and_Places",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PEOPLE AND PLACES")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-1",
    attrs: {
      "id": "ata"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/About_the_Author#rata",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ABOUT THE AUTHOR")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "obb"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062290953_Other_Books#robb",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ALSO BY DIANA L. PAXSON")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "cop"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062290953_Copyright#rcop",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("COPYRIGHT")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "atp"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/About_the_Publisher#ratp",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ABOUT THE PUBLISHER")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1775f832","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780062290953_Contents.vue
// module id = 72
// module chunks = 0